module.exports = __webpack_public_path__ + "img/galardon.d1eb2240.png";